import { PropsWithChildren } from 'react'

import {
  AnswerContextProvider,
  AnswerContextProviderProps,
  AnswerContextProviderType,
} from '../../contexts/AnswerContext'
import {
  AssociatedAnswersPreview,
  AssociatedAnswersPreviewType,
} from './AssociatedAnswersPreview'
import { EmployeeReadOnly, EmployeeReadOnlyType } from './EmployeeReadOnly'
import { ManagerAnswerReadOnly } from './ManagerAnswerReadOnly'
import { ManagerComment, ManagerCommentType } from './ManagerComment'
import {
  ManagerCommentReadOnly,
  ManagerCommentReadOnlyType,
} from './ManagerCommentReadOnly'

export const Answer: AnswerContextProviderType &
  EmployeeReadOnlyType &
  ManagerCommentType &
  ManagerCommentReadOnlyType &
  AssociatedAnswersPreviewType & {
    ManagerAnswerReadOnly: typeof ManagerAnswerReadOnly
  } = ({
  children,
  ...props
}: PropsWithChildren<AnswerContextProviderProps>) => (
  <AnswerContextProvider {...props}>{children}</AnswerContextProvider>
)

Answer.ManagerComment = ManagerComment
Answer.EmployeeReadOnly = EmployeeReadOnly
Answer.ManagerAnswerReadOnly = ManagerAnswerReadOnly
Answer.ManagerCommentReadOnly = ManagerCommentReadOnly
Answer.AssociatedAnswersPreview = AssociatedAnswersPreview
